let originalWebSocket: typeof WebSocket | null = null
let isInstalled = false
let isBlocked = false
const trackedSockets = new Set<WebSocket>()

const isSipWebSocketUrl = (url: string | URL): boolean => {
  try {
    const parsed = new URL(String(url), window.location.href)
    if (!['ws:', 'wss:'].includes(parsed.protocol)) return false

    return parsed.pathname === '/ws' || parsed.pathname.endsWith('/asterisk/ws')
  } catch {
    return false
  }
}

export const installSipWebSocketLifecycle = () => {
  if (isInstalled || typeof window === 'undefined' || !window.WebSocket) return

  originalWebSocket = window.WebSocket

  window.WebSocket = new Proxy(originalWebSocket, {
    construct(target, args) {
      const [url] = args
      const shouldTrack = isSipWebSocketUrl(url as string | URL)

      if (isBlocked && shouldTrack) {
        throw new DOMException('SIP WebSocket is blocked after logout', 'InvalidStateError')
      }

      const socket = Reflect.construct(target, args) as WebSocket

      if (shouldTrack) {
        trackedSockets.add(socket)
        socket.addEventListener('close', () => trackedSockets.delete(socket), { once: true })
      }

      return socket
    },
  }) as typeof WebSocket

  isInstalled = true
}

export const setSipWebSocketsBlocked = (blocked: boolean) => {
  isBlocked = blocked
}

export const closeTrackedSipWebSockets = () => {
  trackedSockets.forEach((socket) => {
    if (socket.readyState === WebSocket.CLOSED || socket.readyState === WebSocket.CLOSING) return
    socket.close(1000, 'Session closed')
  })
  trackedSockets.clear()
}
